<script>
    import { Icon, Segments, Segment, Text, Label, initLabel } from "svantic";
    initLabel()

    import { Grid, Row, Column } from "svantic";
    import { onMount } from "svelte";
    import { PlayingCard } from "../playingcard/index";

    const ScatterTable = {
        scarab: {
            base: {
                0: 0,
                2: 2,
                6: 3,

                50: 4,
                500: 5
            },
            bonus: {
                0: 0,
                6: 2,
                18: 3,
                150: 4,
                1500: 5
            }
        }
    }
    onMount(() => {
        //console.log("-- bet list item mounted!")


        return () => {
            //console.log("-- bet list item unmounted")
        };
    })

    export let bet = {}

    let BetData = {
        bid: bet.id,
        hid: bet.iid,
        game: bet.game,
        payoutMultiplier: bet.payoutMultiplier,
        result: { ... bet.result },
    }

    async function textToClipboard(text) {
         // write house bet id to clipboard
        if(navigator)
                await navigator.clipboard.writeText(BetData.hid) 
    }
</script>


<div class="bet-result-item">
    <Grid>
        <Row>
            <Column  wide="one" visibility="computer only"> 
                <span class="game-name"> {BetData.game}</span>
            </Column>
            <Column  wide="four"> 
                <Segment  basic fitted aligned="left">
                
                    <a href class="link" title={BetData.hid} on:click|preventDefault={() => textToClipboard(BetData.hid)}> {(BetData.hid.split(":"))[1]} </a>
                </Segment>
            </Column>

            <Column wide="eleven"> 
                <Grid>
                    <Row>

                        {#if BetData.game == "limbo"}
                        <Column wide="six">
             
                                <Text class={ (BetData.payoutMultiplier != 0) ? " green" : "red" }>
                                    {BetData.result.result}<Icon name="times" size="small" />
                                </Text>
                 
                        </Column>
                        <Column wide="six">
                
                                <Icon name="greater than equal" size="small"></Icon>  {BetData.result.multiplierTarget}
                             
                        </Column>

                        {:else if BetData.game == "packs"}
                        <Column wide="four">

                                <Text class={ BetData.payoutMultiplier >= 1 ? " green" : "red" }>
                                    {BetData.payoutMultiplier}<Icon name="times" size="small" />
                                </Text>

                        </Column>
                        <Column wide="six" floated="left">
         
                             
                        </Column>
                        {:else if BetData.game == "dice"}
                        <Column wide="four">

                                <Text class={ (BetData.payoutMultiplier != 0) ? " green" : "red" }>
                                    {BetData.payoutMultiplier}<Icon name="times" size="small" />
                                </Text>

                        </Column>
                        <Column wide="six" floated="left">
         
                              <Text class={ BetData.payoutMultiplier > 0 ? "large green" : " large grey"}> { (Math.floor(BetData.result.result*100)/100).toFixed(2) }</Text>
                              <Text secondary>  <Icon name={ (BetData.result.condition == "above") ? "greater than" : "less than" } size="small"></Icon>  {(Math.floor(BetData.result.target*100)/100)}</Text>
                         
                        </Column>
                        {:else if BetData.game == "dragontower"}
                            <Column wide="four">
                                <Text class={ (BetData.payoutMultiplier != 0) ? " green" : "red" }>
                                    {BetData.payoutMultiplier}<Icon name="times" size="small" />
                                </Text>

                            </Column>
                            <Column wide="four">
                            
                                difficulty:  {BetData.result.difficulty} 
            
                            </Column>
                        {:else if BetData.game == "videopoker"}
                        <Column wide="four">

                                <Text class={ (BetData.payoutMultiplier != 0) ? " green" : "red" }>
                                    {BetData.payoutMultiplier}<Icon name="times" size="small" />
                                    [{BetData.result.handResult}]
                                </Text>

                        </Column>
                        <Column wide="ten" floated="left">
         
                            {#each bet.result.playerHand as card,i (i)}
                                <PlayingCard size="mini" {...card} noFlip={true}></PlayingCard>
                            {/each}
                        </Column>

                        {:else if  BetData.game == "wheel"}
                        <Column wide="eight">
                            <Segment basic fitted="vertically" aligned="center">
                                <Text class={ (BetData.payoutMultiplier != 0) ? " green" : "red" }>
                                    {BetData.payoutMultiplier}<Icon name="times" size="small" />
                                </Text>
                            </Segment>
                        </Column>
                        <Column wide="eight">
                            <Segment inverted basic fitted="vertically" aligned="center" style={ {"padding-top": "8px", "background-color": "transparent"} }>
                                risk {BetData.result.risk}  | Segments {BetData.result.segments}
                             </Segment>
                        </Column>
                        {:else if BetData.game == "keno"}
                            <Column wide="eight">
                                <Segment basic fitted="vertically" aligned="center">
                                    <Text class={ (BetData.payoutMultiplier != 0) ? " green" : "red" }>
                                        {BetData.payoutMultiplier}<Icon name="times" size="small" />
                                    </Text>
                                </Segment>
                            </Column>
                            <Column wide="eight">
                                <Segment inverted basic fitted="vertically" aligned="left" style={ {"padding-top": "8px", "background-color": "transparent"} }>
                                   <p class="p-result">select: {BetData.result.selectedNumbers.map( v => v+1 ).join(", ")}</p>
                                   <p class="p-result">drawn: {BetData.result.drawnNumbers.map( v => v+1 ).join(", ")}</p>
                                </Segment>
                            </Column>
                        {:else if BetData.game == "plinko"}
                            <Column wide="four">
                               
                                    <Text class={ (BetData.payoutMultiplier < 120) ? "orange" : " red" }>
                                        {BetData.payoutMultiplier}<Icon name="times" size="small" />
                                    </Text>
    
                            </Column>
                            <Column wide="four">
                               
                                    {BetData.result.risk} , rows {BetData.result.rows}
              
                            </Column>
                       
                        {:else if BetData.game == "mines"}
                            <Column wide="four">
                                <Text class={ (BetData.payoutMultiplier != 0) ? " green" : "red" }>
                                    {BetData.payoutMultiplier}<Icon name="times" size="small" />
                                </Text>
    
                            </Column>
                            <Column wide="four">
                               
                                  mines:  {BetData.result.minesCount} 
              
                            </Column>
                        {:else if BetData.game == "scarabspin" || BetData.game == "tomeoflife"}
                        <Column wide="four">
                           
                                <Text class={ (BetData.payoutMultiplier != 0) ? " green" : "red" }>
                                    {BetData.payoutMultiplier}<Icon name="times" size="small" />
                                </Text>

                        </Column>
                        <Column wide="five">
       
                                <img class="img-icon" alt="scatters" src="assets/img/scarab_scatter.png" style="/*width: 24px; height: 24px;*/ vertical-align: middle;">
                                <Text class="{ (ScatterTable.scarab.base[BetData.result.rounds[0].scatterMultiplier] <= 2) ? "medium blue" : "" } { (ScatterTable.scarab.base[BetData.result.rounds[0].scatterMultiplier] > 3) ? " red" : "blue" } "> { ScatterTable.scarab.base[BetData.result.rounds[0].scatterMultiplier] }</Text>
                         </Column>
                         <Column wide="five">     
                                  <span style="padding-inline: 8px;">
                                    FS <Text class={(BetData.result.result[BetData.result.result.length-1].bonusTotal >= 45) ? "red" : "blue"}> {  BetData.result.result[BetData.result.result.length-1].bonusTotal}</Text>
                                  </span>      
                     
                        </Column>
                        

                        {:else if BetData.game == "diamonds"}
                        <Column wide="four">
          
                                <Text class={ (BetData.payoutMultiplier != 0) ? " green" : "red" }>
                                    {BetData.payoutMultiplier}<Icon name="times" size="small" />
                                </Text>
 
                        </Column>
                        <Column wide="twelve">   
                                    <Label.Group inverted circular class="horizontal" size="mini" style={ {"vertical-align": "middle", display: "inline-flex"} }>                                    
                                        {#each BetData.result.result as dia,i (i) }
                                            <Label class={"diamond "+dia}> </Label>    
                                        {/each}
                                    </Label.Group>                             
                        </Column>
                        {:else if BetData.game == "hilo"}
                        <Column wide="four">
          
                                <Text class={ (BetData.payoutMultiplier != 0) ? " green" : "red" }>
                                    {BetData.payoutMultiplier}<Icon name="times" size="small" />
                                </Text>
 
                        </Column>
                        <Column wide="twelve">   
                            <div  class="hilo-rounds">
                                <div>
                                    {#if  BetData.result.rounds}
                                         <PlayingCard {... BetData.result.startCard} size="mini" noFlip={true}></PlayingCard>
                                        {#each  BetData.result.rounds as round,i (i)}
                                            <PlayingCard {...round.card} size="mini" disabled={ round.guess == "skip" ? true : false } noFlip={true}></PlayingCard>
                                        {/each}
                                    {/if}
                                </div>
                            </div>                     
                        </Column>

                        {:else if BetData.game == "samurai"}
                        <Column wide="six">
             
                                <Text class={ (BetData.payoutMultiplier != 0) ? " green" : "red" }>
                                    {BetData.payoutMultiplier}<Icon name="times" size="small" />
                                </Text>
                 
                        </Column>
                        <Column wide="six">
                
                              
                             
                        </Column>

                        {:else}

                        <Column wide="eight">
                            <Segment basic fitted="vertically" inverted aligned="center">  <span> no data</span> </Segment>
                        </Column>

                        {/if}
        
                    </Row>
                </Grid>
            </Column>

        </Row>
    </Grid>
</div>

<style>

.img-icon {
    padding-inline: 0.2em;
    height: 32px;
    display: inline-block;
    line-height: 1;
}
    .segments {

        margin: 0.4rem 0 !important;
    }

    .bet-result-item span{
        color: #fdfdfd;
    }
    .bet-result-item span.huge{
        font-size: large;
    }

    .bet-result-item span.game-name {
        padding-inline: 1em;
        color: #b3b3b3;
        font-size: smaller;
        font-weight: 300;
        font-style: italic;
    }

        
    .hilo-rounds {
            width: auto;
            overflow: auto;
            white-space: nowrap;
            padding-block: 0.1em;
    }


    .bet-result-item .diamond {
        font-size: .9078571429rem !important;
    }
    div.link {
        text-decoration: underline;
        color: rgb(113, 166, 252);
        cursor: pointer;
    }

    p.p-result {
        margin-block: 2px;
    }
</style>
